// extracted by mini-css-extract-plugin
export default {"container":"FooterBanner_container__vQ9NB","sidebar":"FooterBanner_sidebar__9tFgA"};